import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";

/**
 * Mobile sticky bottom CTA.
 * Shown below 768px after the user scrolls past the hero
 * and hidden when the calendar section is in view.
 */
export const MobileStickyCTA = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const hero = document.getElementById("hero");
        const calendar = document.getElementById("book-call");
        if (!hero || !calendar) return;

        let pastHero = false;
        let calendarInView = false;

        const update = () => {
            const onMobile = window.innerWidth < 768;
            setVisible(onMobile && pastHero && !calendarInView);
        };

        const heroObserver = new IntersectionObserver(
            ([entry]) => {
                pastHero = !entry.isIntersecting;
                update();
            },
            { threshold: 0 },
        );
        const calObserver = new IntersectionObserver(
            ([entry]) => {
                calendarInView = entry.isIntersecting;
                update();
            },
            { threshold: 0.1 },
        );

        heroObserver.observe(hero);
        calObserver.observe(calendar);
        window.addEventListener("resize", update);

        return () => {
            heroObserver.disconnect();
            calObserver.disconnect();
            window.removeEventListener("resize", update);
        };
    }, []);

    if (!visible) return null;

    return (
        <div
            className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t border-border shadow-[0_-4px_20px_-8px_rgba(0,0,0,0.08)]"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
            data-testid="mobile-sticky-cta"
        >
            <div className="flex items-center justify-between gap-3 px-4 py-3">
                <span className="text-sm font-medium text-slate-700">
                    Book a 30-min audit call
                </span>
                <a
                    href="#book-call"
                    className="inline-flex items-center gap-1.5 bg-primary text-primary-foreground px-4 py-2.5 rounded-md font-medium text-sm min-h-[44px] active:scale-95 transition-transform"
                    data-testid="mobile-sticky-book-btn"
                >
                    Book
                    <ArrowRight className="w-4 h-4" />
                </a>
            </div>
        </div>
    );
};

export default MobileStickyCTA;
